import { useState, useCallback } from 'react'
import api from '@/shared/lib/api'

interface LLRActions {
  gbp_post: string
  ads_headlines: string[]
  ads_descriptions: string[]
  landing_brief: string
}

interface LLRInput {
  keyword: string
  location: string
  intensity_score: number
  business_name: string
  business_type: string
  usps?: string[]
}

export function useAILLRActions() {
  const [actions, setActions] = useState<LLRActions | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const generate = useCallback(async (input: LLRInput) => {
    setIsLoading(true)
    setError(null)
    try {
      const { data } = await api.post('/ai/llr-actions', {
        keyword: input.keyword,
        location: input.location,
        intensity_score: input.intensity_score,
        business_name: input.business_name,
        business_type: input.business_type,
        usps: input.usps || [],
      })
      setActions(data.data)
    } catch (err: any) {
      setError(err?.response?.data?.detail || 'Erreur lors de la génération.')
    } finally {
      setIsLoading(false)
    }
  }, [])

  const reset = useCallback(() => {
    setActions(null)
    setError(null)
  }, [])

  return { generate, actions, isLoading, error, reset }
}
